<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box top-bg-color">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/identity/logo-white.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/identity/logo-white.svg" alt="" height="45">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light logo-to-right">
          <span class="logo-sm">
            <img src="assets/images/identity/logo-white.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/identity/logo-white.svg" alt="" height="45">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" [ngClass]="{ 'd-none': theme === 'horizontal' }" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    
    </div>

    <div class="d-flex">

      <!-- HIDDEN TEMPORARILY -->
      <div class="dropdown d-inline-block d-none" dropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" dropdownToggle>
          @if(flagvalue === undefined){
          <img src="{{valueset}}" alt="Header Language" height="16">
          }@else{
          <img src="{{flagvalue}}" alt="Header Language" height="16">
          }
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          @for (item of listLang; track $index) {
          <a href="javascript:void(0);" class="dropdown-item notify-item" (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
            <img src="{{item.flag}}" alt="user-image" class="me-1" height="12"> <span class="align-middle">{{item.text}}</span>
          </a>
          }
          <!-- item-->
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item" dropdownToggle id="page-header-user-dropdown">
          
          
          @if(user$ | async; as user){
            <img class="rounded-circle header-profile-user" [src]=" user.avatar ?? 'assets/images/users/avatar-2.jpg'" alt="Header Avatar">
          }
          @else{
            <img class="rounded-circle header-profile-user" [src]=" userObj.avatar ?? 'assets/images/users/avatar-2.jpg'" alt="Header Avatar">
          }

          <span class="d-none d-xl-inline-block ms-1">
            <span *ngIf="user$ | async as user">{{ user.first_name }}</span>
            <span *ngIf="!(user$ | async)">{{userObj.first_name ?? "User"}}</span>
          </span>

          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/profile"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.profile' | translate}}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.logout' | translate}}</a>
        </div>
      </div>

    </div>
  </div>
</header>